export default __webpack_public_path__ + "static/media/Mymoviz.ccd973c4.PNG";